import React, { Component } from 'react';
import { PATH } from '../../../constants';
import SearchResults from './SearchResults/SearchResults';
import './SearchBox.css';

class SearchBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTerm: '',
      focus: false,
      open: false,
    };

    // ref
    this.inputRef = React.createRef();

    // bind
    this.handleClick = this.handleClick.bind(this);
    this.handleInputClick = this.handleInputClick.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  // -------------------------------------------------------
  // Input
  // -------------------------------------------------------

  handleBlur() {
    if (this.state.open) {
      this.setState({
        focus: false,
      });
      // try hide (if not already in focus again)
      setTimeout(() => {
        if (!this.state.focus) {
          this.setState({
            searchTerm: '',
            open: false,
          });
        }
      }, 200);
    }
  }

  handleChange(e) {
    this.setState({
      searchTerm: e.target.value,
    });
  }

  // -------------------------------------------------------
  // Click
  // -------------------------------------------------------

  handleClick() {
    if (!this.state.open) {
      this.setState({
        focus: true,
        open: true,
      });
      setTimeout(() => {
        this.inputRef.current.focus();
      }, 100);
    }
  }

  handleInputClick() {
    this.setState({
      focus: true,
    });
  }

  // -------------------------------------------------------
  // Render
  // -------------------------------------------------------

  render() {
    const { open } = this.state;

    return (
      <div id="search-box" className={open ? 'open' : ''}>
        <button id="search-button" onClick={this.handleClick} className={open ? 'inactive' : ''}>
          <img src={`${PATH.IMG}ico/ico-search.png`} alt="Hledat - ikona" />
        </button>
        <input
          id="search-input"
          value={this.state.searchTerm}
          type="text"
          name="Hledat"
          ref={this.inputRef}
          onBlur={this.handleBlur}
          onChange={this.handleChange}
          onClick={this.handleInputClick}
        />
        <SearchResults term={this.state.searchTerm} />
      </div>
    );
  }
}

export default SearchBox;



// WEBPACK FOOTER //
// ./src/components/App/SearchBox/SearchBox.js